import { render, staticRenderFns } from "./BomField.vue?vue&type=template&id=4b6cc6c5"
import script from "./BomField.vue?vue&type=script&lang=js"
export * from "./BomField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports